import { render } from "./RouteGeneral.vue?vue&type=template&id=634b9146&ts=true"
import script from "./RouteGeneral.vue?vue&type=script&lang=ts"
export * from "./RouteGeneral.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__